import { cn } from '@module/lib/utils';
import useChatMessageStore from '@module/stores/useChatMessageStore';
import { ArrowUp } from '@module/svg/icons';
import { isItemCoinMessage, isSponCoinMessage } from '@module/types/centrifuge/public-message/sponCoinMessageTypes';
import { useState } from 'react';

function SponSummary() {
  const [isOpen, setIsOpen] = useState(false);

  const sponMessages = useChatMessageStore((state) => state.sponMessages);

  const sponList = sponMessages.slice(-10);

  const renderSponList = isOpen ? sponList : sponList.slice(-3);

  if (sponList.length < 1) return <></>;

  return (
    <ul className='border-borderBg01 border-b bg-baseBg p-2.5 text-[14px] text-cht_baseFg'>
      {renderSponList.map((item) => {
        const isViewerSignature = isSponCoinMessage(item) && 'heart' in item.data.message;
        const isSignature = isViewerSignature;
        const isSpecial = isItemCoinMessage(item);
        const isNormal = !isSpecial && !isSignature;

        return (
          <li key={item.offset} className='flex items-center truncate'>
            <span>{item.data.message.nick}님이</span>&nbsp;
            <span className='relative inline truncate'>
              <div className='-left-1 -right-1 absolute bottom-0 block h-[6px] bg-colorBg_gift_txt_box' />
              <span className='relative'>
                {isNormal && '하트'}
                {isSpecial && '스페셜하트'}
                {isSignature && '시그니처하트'}
              </span>
              &nbsp;
              <span className='relative font-bold'>{item.data.message.coin} 개</span>
              <span className='relative'>&nbsp;선물!</span>
            </span>
          </li>
        );
      })}
      {sponList.length > 3 && (
        <div className='flex justify-end'>
          <button
            className={cn(
              'flex h-7 w-7 rotate-180 items-center justify-center rounded-full border-2 border-borderBg02',
              {
                'rotate-0': isOpen,
              },
            )}
            onClick={() => setIsOpen(!isOpen)}
          >
            <ArrowUp style={{ color: 'var(--borderBg02)', fontSize: 5 }} />
          </button>
        </div>
      )}
    </ul>
  );
}

export default SponSummary;
